import React from 'react';

interface HeroProps {
  theme: 'cnw' | 'krissco';
  hero: {
    eyebrow: string;
    title: string;
    description: string;
    chips: string[];
  };
  subStrip?: {
    label: string;
    items: Array<{ main: string; sub: string }>;
  };
}

const HandbookHero: React.FC<HeroProps> = ({ theme, hero, subStrip }) => {
  const renderIconText = (text: string) => {
    // Check if the text is one of our mapped Material Icons
    const iconMap: Record<string, string> = {
      'assignment': 'assignment',
      'domain': 'domain',
      'calendar_today': 'calendar_today',
      'lock': 'lock',
      'track_changes': 'track_changes',
      'bar_chart': 'bar_chart',
      'warning': 'warning',
      'account_balance': 'account_balance',
      'call': 'call',
      'chat': 'chat',
      'campaign': 'campaign',
      'person': 'person',
      'school': 'school',
      'work': 'work'
    };

    const parts = text.split(' ');
    const firstWord = parts[0];

    if (iconMap[firstWord]) {
      return (
        <>
          <span className="material-symbols-outlined icon-inline">{firstWord}</span>
          {' '}{parts.slice(1).join(' ')}
        </>
      );
    }
    return text;
  };

  return (
    <>
      <div className="handbook-hero">
        <div className="hero-eyebrow">
          {renderIconText(hero.eyebrow)}
        </div>

        {/* We use dangerouslySetInnerHTML to support <span> or <br> tags injected by the parser */}
        <h1
          className="hero-title"
          dangerouslySetInnerHTML={{ __html: hero.title }}
        />

        <p className="hero-desc">{hero.description}</p>

        <div className="hero-chips">
          {hero.chips.map((chip, i) => (
            <span key={i} className="chip">
              {renderIconText(chip)}
            </span>
          ))}
        </div>
      </div>

      {theme === 'krissco' && subStrip && (
        <div className="sub-strip">
          <span className="sub-strip-label">{subStrip.label}</span>
          {subStrip.items.map((item, i) => (
            <span key={i} className="sub-item">
              {item.main} <span>{item.sub}</span>
            </span>
          ))}
        </div>
      )}
    </>
  );
};

export default HandbookHero;
